import React from 'react';
import { Container, Row, Col, Card } from "react-bootstrap";

export default function Privacy() {
  return (
    <div className="explore-page" style={{ minHeight: "100vh" }}>
      <div className="star-field">
        {Array.from({ length: 100 }).map((_, i) => (
          <div
            key={i}
            className="star"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`
            }}
          />
        ))}
      </div>

      <Container fluid className="py-5">
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            <div className="text-center mb-5">
              <img 
                src="/sparkthinking.png"
                alt="AniSpark Mascot" 
                className="mascot-image mb-4"
                style={{
                  width: '120px',
                  height: '120px',
                  filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.3))'
                }}
              />
              <h1 className="text-light mb-3" style={{ fontSize: '3rem', fontWeight: '700' }}>
                Privacy Policy
              </h1>
              <p className="text-light" style={{ fontSize: '1.2rem', opacity: 0.9 }}>
                <strong>Last Updated:</strong> June 13, 2025
              </p>
            </div>

            <Row className="g-4">
              <Col md={12}>
                <Card 
                  className="mb-4"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-5">
                    <h2 className="text-light mb-4" style={{ color: '#facc15', fontSize: '2rem', fontWeight: '600' }}>
                      1. Introduction
                    </h2>
                    <p className="text-light" style={{ fontSize: '1.1rem', lineHeight: '1.8', opacity: 0.9 }}>
                      Welcome to AniSpark ("we," "our," or "us"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services. Please read this Privacy Policy carefully. If you do not agree with the terms, please do not use the site.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      2.1 Personal Information
                    </h3>
                    <p className="text-light mb-3" style={{ opacity: 0.9 }}>
                      We may collect personal information that you voluntarily provide, including:
                    </p>
                    <ul className="text-light" style={{ opacity: 0.9 }}>
                      <li className="mb-2">Email address</li>
                      <li className="mb-2">Username and display name</li>
                      <li className="mb-2">Profile information (bio, creator links like Patreon/Ko-fi)</li>
                      <li className="mb-2">Contact information when you reach out to us</li>
                      <li className="mb-2" style={{ fontStyle: 'italic' }}>Metadata related to creator status, badges, or supporter designations</li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      2.2 Usage Information
                    </h3>
                    <p className="text-light mb-3" style={{ opacity: 0.9 }}>
                      We automatically collect certain information, such as:
                    </p>
                    <ul className="text-light" style={{ opacity: 0.9 }}>
                      <li className="mb-2">Cookies and similar tracking technologies</li>
                      <li className="mb-2">Video viewing history and interactions</li>
                      <li className="mb-2" style={{ fontStyle: 'italic' }}>NSFW moderation flags applied to uploaded content using third-party analysis</li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      2.3 Content Information
                    </h3>
                    <p className="text-light mb-3" style={{ opacity: 0.9 }}>
                      For creators, we collect:
                    </p>
                    <ul className="text-light" style={{ opacity: 0.9 }}>
                      <li className="mb-2">Uploaded videos and related metadata</li>
                      <li className="mb-2">Creator profile content</li>
                      <li className="mb-2">Performance analytics (e.g., views, likes)</li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      3. How We Use Your Information
                    </h3>
                    <ul className="text-light" style={{ opacity: 0.9, listStyle: 'none', paddingLeft: 0 }}>
                      <li className="mb-2">To provide and maintain our services</li>
                      <li className="mb-2">To manage user accounts and roles</li>
                      <li className="mb-2">To personalize content and recommendations</li>
                      <li className="mb-2">To <strong style={{ color: '#facc15' }}>analyze and moderate uploads</strong> using third-party tools</li>
                      <li className="mb-2">To route fans to external support links (e.g., Patreon)</li>
                      <li className="mb-2">To show relevant ads, where applicable</li>
                      <li className="mb-2">To ensure platform security and integrity</li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={12}>
                <Card 
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-5">
                    <h2 className="text-light mb-4" style={{ color: '#facc15', fontSize: '2rem', fontWeight: '600' }}>
                      4. Information Sharing and Disclosure
                    </h2>
                    <Row className="g-3">
                      <Col md={6}>
                        <h4 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.3rem', fontWeight: '600' }}>
                          4.1 Public Information
                        </h4>
                        <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                          Creator profiles, public usernames, and uploaded videos are viewable by all site visitors.
                        </p>
                      </Col>
                      <Col md={6}>
                        <h4 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.3rem', fontWeight: '600' }}>
                          4.2 Service Providers
                        </h4>
                        <p className="text-light mb-2" style={{ opacity: 0.9 }}>We share data with providers including:</p>
                        <ul className="text-light" style={{ opacity: 0.9, fontSize: '0.95rem' }}>
                          <li>Firebase (authentication and database)</li>
                          <li>Cloudflare Stream (video hosting and delivery)</li>
                          <li>SightEngine (content moderation)</li>
                          <li>Ad networks like Google AdSense and Carbon Ads</li>
                        </ul>
                      </Col>
                      <Col md={6}>
                        <h4 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.3rem', fontWeight: '600' }}>
                          4.3 Legal Requirements
                        </h4>
                        <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                          We may disclose information to comply with legal obligations or law enforcement requests.
                        </p>
                      </Col>
                      <Col md={6}>
                        <h4 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.3rem', fontWeight: '600' }}>
                          4.4 Business Transfers
                        </h4>
                        <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                          User information may be transferred during a business sale, merger, or acquisition.
                        </p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      5. Advertising and Analytics
                    </h3>
                    <p className="text-light mb-3" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      We use advertising networks such as Google AdSense and Carbon Ads to serve ads. These services may use cookies to deliver relevant advertising.
                    </p>
                    <p className="text-light mb-3" style={{ opacity: 0.8, fontStyle: 'italic' }}>
                      At launch, we may default to non-personalized ads until further platform maturity.
                    </p>
                    <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      We also use analytics services to understand user behavior and improve the platform.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      6. Data Security
                    </h3>
                    <p className="text-light mb-4" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      We implement safeguards to protect your information, but no system is 100% secure.
                    </p>
                    
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      7. Data Retention
                    </h3>
                    <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      We retain data as long as necessary for operational and legal reasons. When users delete their account, personal data will be deleted or anonymized within a reasonable time.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      8. Your Rights and Choices
                    </h3>
                    <ul className="text-light" style={{ opacity: 0.9, listStyle: 'none', paddingLeft: 0 }}>
                      <li className="mb-2">✓ Access and update your account info</li>
                      <li className="mb-2">✓ Delete your account and data</li>
                      <li className="mb-2">✓ Control cookie preferences in your browser</li>
                      <li className="mb-2">✓ Request information about how your data is used</li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      9. Children's Privacy
                    </h3>
                    <p className="text-light mb-4" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      We do not knowingly collect personal data from children under 13. If discovered, we will remove it promptly.
                    </p>
                    
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      10. International Data Transfers
                    </h3>
                    <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      Data may be transferred outside your country. We ensure safeguards are in place where required.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={12}>
                <Card 
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-5 text-center">
                    <Row>
                      <Col md={6}>
                        <h2 className="text-light mb-4" style={{ color: '#facc15', fontSize: '2rem', fontWeight: '600' }}>
                          11. Updates
                        </h2>
                        <p className="text-light mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.8', opacity: 0.9 }}>
                          We may update this policy periodically. Check this page for the most current version.
                        </p>
                      </Col>
                      <Col md={6}>
                        <h2 className="text-light mb-4" style={{ color: '#facc15', fontSize: '2rem', fontWeight: '600' }}>
                          12. Contact
                        </h2>
                        <p className="text-light mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.8', opacity: 0.9 }}>
                          For questions or concerns, email us at: 
                          <br />
                          <strong style={{ color: '#facc15' }}>support@anispark.co</strong>
                        </p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <style jsx>{`
        .explore-page {
          background: linear-gradient(135deg, #1e1b4b 0%, #3c366b 100%);
          position: relative;
          overflow: hidden;
        }
        
        .star-field {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 1;
        }
        
        .container-fluid {
          position: relative;
          z-index: 2;
        }

        .star {
          position: absolute;
          width: 2px;
          height: 2px;
          background: white;
          border-radius: 50%;
          animation: twinkle 3s ease-in-out infinite;
        }
        
        @keyframes twinkle {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }

        .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        }

        .mascot-image {
          animation: float 3s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
}